import { render, staticRenderFns } from "./departmentDropDown.vue?vue&type=template&id=31d461ee&scoped=true"
import script from "./departmentDropDown.vue?vue&type=script&lang=js"
export * from "./departmentDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d461ee",
  null
  
)

export default component.exports